/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
/* eslint-disable class-methods-use-this */
var ezdia;
(function (ezdia) {
    var TEMPLATES = ezdia.templates.quickActions;
    var QA_LINK_WRAPPER_ID = 'qactiondiv #ez-quick-action-links';
    var QA_CURRENT_LABEL_ID = 'ez-js-quick-action-grid-label';
    var ACTIVE_CLS = 'active';
    var NO_OF_QA_BTN_VISIBLE = 2;
    var POPUP_QUICK_ACTIONS = [
        'sys_share_items',
        'sys_share_items_approval',
        'sys_show_all_ids',
        'sys_show_dropdown',
        'sys_all_ids',
        'sys_selected_ids',
        'sys_selected_show_fields',
        'sys_copy_org_users',
        'eza_send_for_optimization',
        'eza_mark_added',
        'eza_create_new_alert',
        'ga_archive_export',
        'eza_share',
        'eza_share_query'
    ];
    function removeActiveCls() {
        $("#" + QA_LINK_WRAPPER_ID).find("." + ACTIVE_CLS).removeClass(ACTIVE_CLS);
        $("#ez-js-grid-action-quick").removeClass(ACTIVE_CLS);
        $("#ez-js-grid-action-quick-dd")
            .find("." + ACTIVE_CLS)
            .removeClass(ACTIVE_CLS);
    }
    function handelAssignmentListClick() {
        var e_1, _a;
        var ids = ezdia.util.getSelectedGridItemsIds();
        if (!ids.length) {
            ezdia.alert('Error', 'Please select at least one item');
            return;
        }
        var name = this.dataset.name;
        var uKey = ezdia.util.getUniqueKey();
        var _b = ezdia.config, _c = _b.pageParams, assignmentList = _c.assignmentList, account = _c.account, affiliatedBy = _c.affiliatedBy, tooleRole = _c.role, sessionDKey = _b.JS.sessionDKey, contextRoot = _b.user.context_root;
        var currentItem;
        var role = 'pm_customer';
        try {
            for (var assignmentList_1 = __values(assignmentList), assignmentList_1_1 = assignmentList_1.next(); !assignmentList_1_1.done; assignmentList_1_1 = assignmentList_1.next()) {
                var item = assignmentList_1_1.value;
                if (item.name === name) {
                    currentItem = item;
                    break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (assignmentList_1_1 && !assignmentList_1_1.done && (_a = assignmentList_1.return)) _a.call(assignmentList_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (!affiliatedBy || affiliatedBy.toLowerCase() === 'ezdia') {
            role = 'pm';
        }
        var roleName = currentItem.roleName;
        var sessionData = {
            role: role,
            tool_name: account,
            accountName: 'expert',
            tool_role: tooleRole,
            taskId: ids.join(','),
            assignmentName: roleName
        };
        sessionStorage.setItem(uKey, JSON.stringify(sessionData));
        window.open(contextRoot + "/desk/ExpertManagement.htm?" + sessionDKey + "=" + uKey, '_self');
    }
    var QuickActions = /** @class */ (function () {
        function QuickActions() {
        }
        QuickActions.prototype.render = function (arr) {
            this.initialize();
            var context = this.formatQADataObj(arr);
            var html = TEMPLATES.getMarkup(context);
            if (!context.links.length) {
                setTimeout(function () {
                    $('#ez-js-quick-action-grid-links').find('button').hide();
                }, 0);
            }
            return "<div id=\"ez-quick-action-links\">" + html + "</div>";
        };
        QuickActions.prototype.setSelection = function (elem) {
            var viewType = elem.data().viewType;
            if (viewType === 'dd') {
                var id = elem.data('dd');
                var label = elem.data('label');
                $("#" + id).html("" + decodeURIComponent(label));
            }
            this.setActiveCls(elem, viewType);
        };
        QuickActions.prototype.resetQuickActionLink = function () {
            this.resetProps();
            removeActiveCls();
            $('#quickactionfield').empty();
            $("#" + QA_CURRENT_LABEL_ID).html('More');
        };
        QuickActions.prototype.handelOnClick = function (event) {
            var currentTarget = event.currentTarget;
            var $currentTarget = $(currentTarget);
            var type = $currentTarget.data().type;
            var lastSelectedType = this.currentAction.type;
            if (lastSelectedType === type) {
                this.clearLastAction();
                return;
            }
            var currentAction = this.actionItems[type] || {};
            var popup = currentAction.popup;
            var isValidNo = this.validateSelectedItemsLimit(currentAction);
            if (isValidNo) {
                this.renderSelectedAction(currentAction, event);
                if (!popup) {
                    this.setCurrentIds();
                    this.currentAction = currentAction;
                    ezdia.config.currentQuickAction = type;
                    this.highlightSelectedAction(popup, $currentTarget);
                }
            }
        };
        QuickActions.prototype.validateItemsLimitOnGridSelect = function (
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        gridId, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        rowid, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        event) {
            var isEmptyActions = !Object.keys(this.currentAction).length;
            var isValidSelection = true;
            if (isEmptyActions) {
                return isValidSelection;
            }
            isValidSelection = this.validateSelectedItemsLimit(this.currentAction);
            if (!isValidSelection) {
                // eslint-disable-next-line no-console
                console.log('error');
            }
            return isValidSelection;
        };
        QuickActions.prototype.updateWithNewSelection = function (gridId, rowid, clicked) {
            if (this.deselectInprogress) {
                return;
            }
            var ids = ezdia.util.getSelectedGridItemsByGridId(gridId);
            var idsLen = ids.length;
            if (idsLen) {
                this.confirmationToUpdate(rowid, clicked);
            }
        };
        QuickActions.prototype.isQuickActionSelected = function () {
            return !!Object.keys(this.currentAction || {}).length;
        };
        QuickActions.prototype.updateSelectedIdsOnView = function (selIds) {
            var ids = selIds || this.currentIds;
            var html = TEMPLATES.quickActionSeletedId({
                text: ids.join(', '),
                count: ids.length,
                btnTitle: 'Copy Selected Ids'
            });
            $('#ez-js-form-item-info').html(html);
            ezdia.util.copyBtnAction({});
        };
        QuickActions.prototype.deselctRows = function (rowid, isSelectAll) {
            this.deselectInprogress = true;
            if (!isSelectAll) {
                this.removeSlectedItemsFromGrid(rowid, false);
            }
            else {
                this.removeSlectedItemsFromGrid(rowid, true);
            }
        };
        QuickActions.prototype.renderShadowLinks = function (btnsWrapper) {
            var markup = TEMPLATES.getMarkup(this.qaItems, true);
            btnsWrapper.append("<div class=\"ez-grid-action-btns-group\">" + markup + "</div>");
            this.bindShadowAction(btnsWrapper);
            this.toggleMenu(btnsWrapper);
        };
        QuickActions.prototype.renderAssignmentList = function (btnsWrapper) {
            var eventType = '.ez.assignmentList';
            var assignmentList = $.ezdia.config.pageParams.assignmentList;
            var markup = TEMPLATES.getAssignmentList(assignmentList);
            btnsWrapper.append("" + markup);
            var $markup = markup
                .replace('ez-assignment-list-grid', 'ez-assignment-list-link')
                .replace('ez-grid-action-btns-group', 'btn-group');
            $("#ez-assignment-list-wrapper").replaceWith($markup);
            $("#ez-assignment-list-link")
                .off(eventType)
                .on("click" + eventType, 'a', handelAssignmentListClick);
            $("#ez-assignment-list-grid")
                .off(eventType)
                .on("click" + eventType, 'a', handelAssignmentListClick);
        };
        QuickActions.prototype.checkoutBtn = function (btnsWrapper) {
            var markup = TEMPLATES.checkout();
            btnsWrapper.append(markup);
            $('#ez_js__grid__check-out').on('click', function click() {
                ezdia.pages.content.checkout();
            });
        };
        QuickActions.prototype.popupQuickActionForm = function (actiontype, data) {
            var e_2, _a, e_3, _b;
            if (data === void 0) { data = {}; }
            var quickactionObj = $.ezdia.config.pageParams.quickactionObj;
            var qaObject;
            try {
                for (var quickactionObj_1 = __values(quickactionObj), quickactionObj_1_1 = quickactionObj_1.next(); !quickactionObj_1_1.done; quickactionObj_1_1 = quickactionObj_1.next()) {
                    var quickaction = quickactionObj_1_1.value;
                    var name_1 = quickaction.name;
                    if (name_1 === actiontype) {
                        qaObject = $.extend(true, {}, quickaction);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (quickactionObj_1_1 && !quickactionObj_1_1.done && (_a = quickactionObj_1.return)) _a.call(quickactionObj_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            if (!qaObject) {
                return;
            }
            if (typeof qaObject.config === 'string') {
                qaObject.config = ezdia.util.jsonParse(qaObject.config);
            }
            var formId = ezdia.util.makeId();
            var form = $('<form>', {
                id: formId,
                class: 'ezdia-form'
            });
            var fields = qaObject.quickActionFields;
            try {
                for (var _c = __values(Object.entries(fields)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var _e = __read(_d.value, 2), name_2 = _e[0], column = _e[1];
                    column.name = name_2;
                    column.id = ezdia.util.makeId();
                    column.edittype = column.fieldType;
                    var value = data[name_2];
                    var input = $.ezdia.inputs.getMarkup({ column: column, value: value });
                    form.append(input);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                }
                finally { if (e_3) throw e_3.error; }
            }
            this.createPopupDialog(form, formId, qaObject);
            $.ezdia.widgets.renderAll(fields, actiontype);
            $.ezdia.validate.all(fields, formId);
        };
        QuickActions.prototype.popupQuickActions = function (type) {
            var selIds = ezdia.util.getSelectedGridItemsIds();
            var isMany = selIds.length > 10;
            var ids = selIds;
            if (isMany) {
                ids = selIds.slice(0, 9);
            }
            this.createConfirmChangesDialog({
                type: type,
                ids: ids,
                allIds: selIds,
                isMany: isMany,
                idsCount: selIds.length,
                textBoxId: ezdia.util.makeId(),
                copyBtnId: ezdia.util.makeId()
            });
        };
        QuickActions.prototype.createPopupDialog = function (form, formId, qaObject) {
            var self = this;
            var title = qaObject.title, btnlabel = qaObject.btnlabel;
            var wrapperID = "ez-js-alert-from";
            var wrapper = ezdia.util.getWrapper(wrapperID);
            wrapper.html(form).dialog({
                title: title,
                modal: true,
                width: 650,
                height: 400,
                buttons: [
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: btnlabel,
                        class: 'btn-primary',
                        click: function () {
                            self.savePopupForm(formId, qaObject, this);
                        }
                    }
                ]
            });
        };
        QuickActions.prototype.savePopupForm = function (id, qaObject, dialog) {
            return __awaiter(this, void 0, void 0, function () {
                var name, url, form, _a, dateRange, channel, formType, formData, selectAll, dateObject, queryString, recordCount, ids, _b, fromDate, toDate, compareFromDate, compareToDate, data, response, ex_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            name = qaObject.name, url = qaObject.config.data_action;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            form = $("#" + id);
                            if (!form.valid()) {
                                return [2 /*return*/];
                            }
                            _a = $.ezdia.config
                                .pageParams, dateRange = _a.dateRange, channel = _a.channel, formType = _a.formType;
                            formData = form.serializeObject();
                            selectAll = $('#selectAll').is(':checked');
                            dateObject = {};
                            queryString = void 0;
                            recordCount = void 0;
                            ids = [];
                            if (selectAll) {
                                recordCount = $('#grid').jqGrid('getGridParam', 'records');
                                queryString = $('#searchFrm').search('getQueryString');
                            }
                            else {
                                ids = ezdia.util.getSelectedGridItemsByGridId();
                            }
                            if (name === 'eza_share') {
                                _b = __read(ezdia.util.getUrlParams([
                                    'fromDate',
                                    'toDate',
                                    'compareFromDate',
                                    'compareToDate'
                                ]), 4), fromDate = _b[0], toDate = _b[1], compareFromDate = _b[2], compareToDate = _b[3];
                                dateObject = {
                                    fromDate: fromDate,
                                    toDate: toDate,
                                    compareFromDate: compareFromDate,
                                    compareToDate: compareToDate
                                };
                            }
                            data = __assign(__assign(__assign({}, formData), dateObject), { dateRange: dateRange,
                                channel: channel,
                                queryString: queryString,
                                recordCount: recordCount, id: ids.join(','), formtype: formType, type: name });
                            return [4 /*yield*/, ezdia.Http.post({
                                    url: url,
                                    data: data
                                })];
                        case 2:
                            response = _c.sent();
                            if (response.success) {
                                ezdia.util.showSuccessError({
                                    message: response.msg
                                });
                                $(dialog).dialog('close');
                            }
                            else {
                                // eslint-disable-next-line prefer-promise-reject-errors
                                Promise.reject({ msg: response.msg });
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            ex_1 = _c.sent();
                            console.error(ex_1);
                            ezdia.util.showSuccessError({
                                message: ex_1.msg || 'Error updating data. Please try again.',
                                error: true,
                                autohide: false
                            });
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        QuickActions.prototype.createConfirmChangesDialog = function (props) {
            var self = this;
            var wrapper = ezdia.util.getWrapper('ez-dialog-confirm');
            var popupContent = TEMPLATES.confirmChangesMsg(props);
            var textBoxId = props.textBoxId, copyBtnId = props.copyBtnId, isMany = props.isMany, type = props.type, allIds = props.allIds;
            wrapper.html(popupContent);
            wrapper.dialog({
                closeOnEscape: false,
                open: function () {
                    $('.ui-dialog-titlebar-close').hide();
                },
                resizable: false,
                modal: true,
                title: 'Confirm Changes',
                width: 600,
                maxHeight: 400,
                buttons: [
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Confirm',
                        class: 'btn-primary',
                        click: function () {
                            self.savePopupActions.call(self, $(this), type, allIds);
                        }
                    }
                ]
            });
            if (isMany) {
                var btn = wrapper.find('button');
                btn.on('click', function click() {
                    var $this = $(this);
                    $this
                        .closest('span[data-container]')
                        .hide()
                        .siblings('span[data-container]')
                        .show();
                });
            }
            ezdia.util.copyBtnAction({
                btnId: copyBtnId,
                inputboxId: textBoxId
            });
        };
        QuickActions.prototype.savePopupActions = function ($dialog, quickActionName, allIds) {
            var e_4, _a, e_5, _b;
            var _c = $.ezdia.config.pageParams, quickactionObj = _c.quickactionObj, formType = _c.formType;
            var data = {
                formtype: formType,
                quickActionName: quickActionName,
                ids: allIds.join(',')
            };
            var QAObj;
            try {
                for (var quickactionObj_2 = __values(quickactionObj), quickactionObj_2_1 = quickactionObj_2.next(); !quickactionObj_2_1.done; quickactionObj_2_1 = quickactionObj_2.next()) {
                    var quickaction = quickactionObj_2_1.value;
                    var name_3 = quickaction.name, quickActionFields = quickaction.quickActionFields, btnlabel = quickaction.btnlabel;
                    if (name_3 === quickActionName) {
                        data.btnlabel = btnlabel;
                        QAObj = quickaction;
                        try {
                            for (var _d = (e_5 = void 0, __values(Object.entries(quickActionFields))), _e = _d.next(); !_e.done; _e = _d.next()) {
                                var _f = __read(_e.value, 2), filedName = _f[0], column = _f[1];
                                var value = column.value;
                                data[filedName] = value;
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                        break;
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (quickactionObj_2_1 && !quickactionObj_2_1.done && (_a = quickactionObj_2.return)) _a.call(quickactionObj_2);
                }
                finally { if (e_4) throw e_4.error; }
            }
            this.ajaxSavePopup(data, QAObj, $dialog);
        };
        QuickActions.prototype.ajaxSavePopup = function (data, QAObj, $dialog) {
            var self = this;
            $.ajax({
                type: 'POST',
                url: QAObj.actionUrl,
                data: data,
                dataType: 'text',
                success: function (response) {
                    self.handelSavePopupSuccess(response, $dialog);
                },
                error: function (response) {
                    // eslint-disable-next-line no-console
                    console.log(response);
                }
            }).always(function () {
                //
            });
        };
        QuickActions.prototype.handelSavePopupSuccess = function (response, $dialog) {
            var responseObj = ezdia.util.jsonParse(response);
            var message = responseObj.msg, success = responseObj.success;
            var props = {
                message: message,
                error: !success
            };
            if (success) {
                $dialog.dialog('close');
            }
            else {
                props.autohide = false;
            }
            ezdia.util.showSuccessError(props);
        };
        QuickActions.prototype.bindShadowAction = function (btnsWrapper) {
            btnsWrapper
                .find("[data-dd=\"" + QA_CURRENT_LABEL_ID + "\"]")
                .on('click', this.handelShadowAction);
        };
        QuickActions.prototype.handelShadowAction = function () {
            var element = $(this);
            var id = element.data().id;
            $("#" + id).trigger('click');
        };
        QuickActions.prototype.toggleMenu = function (btnsWrapper) {
            var btn = btnsWrapper.find("[data-toggle=\"dropdown\"]");
            var menu = btnsWrapper.find(".quick-actions-dropdown-menu");
            var popperInstance = Popper.createPopper(btn[0], menu[0], {
                placement: 'bottom-end',
                modifiers: [
                    {
                        name: 'flip',
                        fallbackPlacements: ['left', 'top']
                    }
                ]
            });
            btn
                .parent()
                .on('shown.bs.dropdown', function () {
                popperInstance.update();
            })
                .on('hidden.bs.dropdown', function () {
                popperInstance.setOptions({
                    modifiers: [{ name: 'eventListeners', enabled: false }]
                });
            });
            btn.on('click', function () {
                popperInstance.setOptions({
                    modifiers: [{ name: 'eventListeners', enabled: true }]
                });
            });
        };
        QuickActions.prototype.clearLastAction = function () {
            var min = this.currentAction.min;
            this.resetQuickActionLink();
            this.toogleDisplay();
            if (min === 0) {
                var selectAll = $('#selectAll').is(':checked');
                var ids = ezdia.util.getSelectedGridItemsByGridId();
                if (!selectAll && !ids.length) {
                    ezdia.component.form.hide();
                }
            }
        };
        QuickActions.prototype.toogleDisplay = function () {
            var selIds = ezdia.util.getSelectedGridItemsByGridId();
            var grid = $('#grid');
            if (selIds.length === 1) {
                var ids = selIds[0];
                // Don't remove these line of code.
                grid.jqGrid('setSelection', ids, true);
                grid.jqGrid('setSelection', ids, true);
                // End
            }
            else if (selIds.length) {
                hideShowDeskForm('');
                this.resetQuickActionLink();
            }
        };
        QuickActions.prototype.resetProps = function () {
            this.currentAction = {};
            this.currentIds = [];
            ezdia.config.currentQuickAction = '';
        };
        QuickActions.prototype.renderSelectedAction = function (currentAction, event) {
            $.ezdia.quickLinks.quickAction(currentAction, event);
        };
        QuickActions.prototype.validateSelectedItemsLimit = function (currentAction) {
            var min = currentAction.min, max = currentAction.max;
            var returnVal = true;
            if (!min && !max) {
                return returnVal;
            }
            var selectItemCount = ezdia.util.getSelectedGridRowCount();
            if (min && min > selectItemCount) {
                this.showSelectionCountError('min', min);
                returnVal = false;
            }
            else if (max && max < selectItemCount) {
                this.showSelectionCountError('max', max);
                returnVal = false;
            }
            return returnVal;
        };
        QuickActions.prototype.showSelectionCountError = function (type, count) {
            var wrap = $.ezdia.getWrapper('ez-js-sys-quick-action-min-max-selection');
            var msg = '';
            if (type === 'min') {
                msg = "You need to have at least " + count + " item(s) to be selected for this Quick Action.";
            }
            else if (type === 'max') {
                msg = "You can have at most " + count + " item(s) selected for this Quick Action.";
            }
            wrap.html(msg);
            wrap.dialog({
                modal: true,
                title: 'Item selection error',
                width: 450,
                height: 200,
                buttons: [
                    {
                        text: 'Close',
                        class: 'btn-default',
                        click: function () {
                            $(this).dialog('close');
                        }
                    }
                ]
            });
        };
        QuickActions.prototype.initialize = function () {
            this.actionItems = {};
            this.currentAction = {};
            this.currentIds = [];
            this.deselectInprogress = false;
            this.isFormUpdate = false;
        };
        QuickActions.prototype.highlightSelectedAction = function (popup, element) {
            if (popup) {
                return;
            }
            this.setSelection(element);
        };
        QuickActions.prototype.setActiveCls = function (elem, viewType) {
            removeActiveCls();
            if (viewType === 'dd') {
                elem
                    .parent()
                    .addClass(ACTIVE_CLS)
                    .closest('ul')
                    .prev()
                    .addClass(ACTIVE_CLS);
            }
            else {
                $("#" + QA_CURRENT_LABEL_ID).html('More');
                elem.addClass(ACTIVE_CLS);
            }
        };
        QuickActions.prototype.formatQADataObj = function (qaArray) {
            var e_6, _a;
            var returnQAItems = {
                label: 'Quick Actions',
                id: 'ez-js-quick-action-grid-links',
                selectedID: QA_CURRENT_LABEL_ID,
                type: 'quickLinks',
                btns: [],
                links: []
            };
            try {
                for (var qaArray_1 = __values(qaArray), qaArray_1_1 = qaArray_1.next(); !qaArray_1_1.done; qaArray_1_1 = qaArray_1.next()) {
                    var qaItem = qaArray_1_1.value;
                    var qaType = qaItem.type;
                    if (qaType === 'eza_create_new_alert') {
                        continue;
                    }
                    if (qaItem.items) {
                        var innerLoopItems = this.formatQADataObjInnerLoop(qaItem);
                        returnQAItems.links.concat(innerLoopItems);
                        continue;
                    }
                    var extendItem = __assign(__assign({}, qaItem), { popup: this.isPopupTypeQuicAction(qaItem.type) });
                    this.actionItems[qaType] = extendItem;
                    returnQAItems.links.push(extendItem);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (qaArray_1_1 && !qaArray_1_1.done && (_a = qaArray_1.return)) _a.call(qaArray_1);
                }
                finally { if (e_6) throw e_6.error; }
            }
            var links = returnQAItems.links;
            var length = links.length;
            if (length) {
                if (length < 4) {
                    returnQAItems.btns = links;
                    returnQAItems.links = [];
                }
                else {
                    returnQAItems.btns = links.splice(0, NO_OF_QA_BTN_VISIBLE);
                    returnQAItems.links = links;
                }
            }
            this.qaItems = returnQAItems;
            return returnQAItems;
        };
        // eslint-disable-next-line consistent-return
        QuickActions.prototype.formatQADataObjInnerLoop = function (qaItem) {
            var e_7, _a;
            var actionUrl = qaItem.actionUrl;
            var returnQAItems = [];
            try {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                for (var _b = __values(Object.entries(qaItem.items)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), _k = _d[0], item = _d[1];
                    var _e = item, label = _e.label, _f = _e.type, type = _f === void 0 ? 'sys_selected_show_fields' : _f;
                    if (type === 'sys_selected_ids') {
                        continue;
                    }
                    var baseItemProps = __assign(__assign({}, item), { disabled: true, label: label, title: label, type: type, popup: this.isPopupTypeQuicAction(type) });
                    var _g = baseItemProps.exmin, exmin = _g === void 0 ? 1 : _g;
                    var extendItem = {};
                    if (type === 'sys_all_ids') {
                        exmin = 0;
                    }
                    extendItem = __assign(__assign({}, baseItemProps), { min: exmin, actionUrl: actionUrl });
                    returnQAItems.push(extendItem);
                    this.actionItems[type] = extendItem;
                    return returnQAItems;
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_7) throw e_7.error; }
            }
        };
        QuickActions.prototype.isPopupTypeQuicAction = function (actionName) {
            return POPUP_QUICK_ACTIONS.includes(actionName);
        };
        QuickActions.prototype.setCurrentIds = function () {
            this.currentIds = __spread(ezdia.util.getSelectedGridItemsByGridId());
        };
        QuickActions.prototype.confirmationToUpdate = function (rowid, clicked) {
            var isFormDirty = $('#bulkEditFrm').isDirty('form');
            var isUpdate = true;
            if (isFormDirty) {
                isUpdate = confirm('Are you sure to make changes');
            }
            if (isUpdate) {
                this.setCurrentIds();
                this.updateSelectedIdsOnView();
                $.ezdia.quickLinks.quickAction(this.currentAction);
            }
            else {
                this.deselectInprogress = true;
                this.removeSlectedItemsFromGrid(rowid, clicked);
            }
        };
        QuickActions.prototype.removeSlectedItemsFromGrid = function (rowid, clicked) {
            var e_8, _a;
            var grid = $('#grid');
            if (!clicked) {
                grid.jqGrid('setSelection', rowid, true);
            }
            else {
                var ids = ezdia.util.getSelectedGridItemsByGridId();
                try {
                    for (var ids_1 = __values(ids), ids_1_1 = ids_1.next(); !ids_1_1.done; ids_1_1 = ids_1.next()) {
                        var id = ids_1_1.value;
                        var incurrentIds = this.currentIds.includes(id);
                        if (!incurrentIds) {
                            grid.jqGrid('setSelection', id, true);
                        }
                    }
                }
                catch (e_8_1) { e_8 = { error: e_8_1 }; }
                finally {
                    try {
                        if (ids_1_1 && !ids_1_1.done && (_a = ids_1.return)) _a.call(ids_1);
                    }
                    finally { if (e_8) throw e_8.error; }
                }
            }
            this.deselectInprogress = false;
        };
        return QuickActions;
    }());
    var component;
    (function (component) {
        component.quickActions = new QuickActions();
    })(component = ezdia.component || (ezdia.component = {}));
})(ezdia || (ezdia = {}));
